import { DefaultConfigOptions } from '@formkit/vue';
import { inputDefinitions } from '@piveau/piveau-hub-ui-modules';

const config: DefaultConfigOptions = {
  inputs: inputDefinitions
};

export default config;
